import { Route, Routes } from "react-router-dom";
import ReversalMadeScreen from "./list";

export default function ReversalMadeRoutes() {
  return (
    <Routes>
      <Route path="/" element={<ReversalMadeScreen />} />
    </Routes>
  );
}
